/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-05 09:53:30
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo, PageResDo} from "src/types/base";
export declare namespace RoleConfigDOI {

	export interface RowDataI {
        role_name: string
        id: number
	}

	export interface QueryRowDataParamsI extends PageDo {
		keyword?: string
	}

	export interface QueryDetailResultI {

	}

	export interface OperateParamsI {
		
	}

}
let promise:any = null
export default class RoleConfigApi {
	/**
	 * 查询列表
	 * @param {RoleConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: PageDo = {page_index: 1, page_size:100000000}):Promise<ResultPageDo<RoleConfigDOI.RowDataI[]>> {
		return Api.post('/auth_login/login/role/data', params)
	}
	/**
	 * 查询列表
	 * @param {{id: number}} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchDetail (params: {id: number}): Promise<Result<RoleConfigDOI.QueryDetailResultI>> {
		return Api.post('/base/garage/detail', params)
	}
	/**
	 * 新增
	 * @param {RoleConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async add(role_name: string):Promise<Result<any>> {
		return Api.post('/auth_login/login/role/add', {role_name})
	}

	/**
	 * 修改
	 * @param {RoleConfigDOI.OperateParamsI} data
	 * @returns {Promise<Result<any>>}
	 */
	static async update(role_id: number, role_name: string):Promise<Result<any>> {
		return Api.post('/auth_login/login/role/edit', {role_id, role_name})
	}

	/**
	 * 删除
	 * @param {Array<number>} data
	 * @returns {Promise<Result<any>>}
	 */
	static async delete(role_id: number):Promise<Result<any>> {
		return Api.post('/auth_login/login/role/delete', {role_id})
    }
    
    static async queryAuthorityByRol(role_id: number):Promise<Result<{power_id: number,power_name: string,power_url:string,type: number}[]>> {
		return Api.post('/auth_login/login/role/power/data', {role_id})
    }
    
    static async queryMenus():Promise<Result<{id: number,power_name: string,power_url:string}[]>> {
		if(!promise) {
            promise  = Api.post('/auth_login/login/menu/load')
        }
        return promise
    }
    
    static async saveAuthority(role_id: number,power_ids:number[]):Promise<Result<any>> {
		return Api.post('/auth_login/login/role/power/add', {role_id,power_ids})
    }
    
    static async queryAllMenu():Promise<ResultPageDo<{id: number,power_name: string,power_url:string}[]>> {
		return Api.post('/auth_login/login/power/data', {type: 2,page_index:1,page_size:100000000})
    }
    static async queryAllPower():Promise<ResultPageDo<{id: number,type: number, power_name: string,power_url:string}[]>> {
		return Api.post('/auth_login/login/power/data', {type: 0,page_index:1,page_size:100000000})
    }

    static async addMenuInterfaceRelateion(data: {menu_id: number,power_ids: number[],authority_levels: 0|1}):Promise<Result<any>> {
		return Api.post('/auth_login/menu_parallelism_power/add',data)
    }
    static async queryMenuInterfaceRelateion(menu_id: number):Promise<Result<{power_id: number}[]>> {
		return Api.post('/auth_login/menu_parallelism_power/query',{menu_id})
    }
}

export function clearMenus() {
    promise = null
}